import React, { useState, SetStateAction, Dispatch, useEffect } from 'react';
import { Card, Button, Form, Popconfirm, Row, Col } from 'antd';
import TextArea from '../../../../ui/TextArea';
import ActionButtonsBar from '../../../../ui/ActionButtonsBar';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import PageContainer from '../../../../CSIComponents/PageContainer';
import Loading from '../../../../Loading';
import MinAndMaxStayItem from './MinAndMaxStayItem';
import Collapse, {Panel} from './../../../../ui/Collapse';
import styles from './index.module.css';
import CSIActionsButtonsComponent from '../../../../Globals/CsiActionButtonsComponent';
import moment,{ Moment } from 'moment';
import { postHelper } from './../../../../../services/helpers';

interface generalType {
  result?:{
    success:boolean
  }
}
interface policyType {
  fridaymax: undefined | string,
  fridaymin: undefined | string,
  mondaymax: undefined | string,
  mondaymin: undefined | string,
  ruledescription: string,
  rulenumber: string,
  saturdaymax: undefined | string,
  saturdaymin: undefined | string,
  sundaymax: undefined | string,
  sundaymin: undefined | string,
  thursdaymax: undefined | string,
  thursdaymin: undefined | string,
  tuesdaymax: undefined | string,
  tuesdaymin: undefined | string,
  wednesdaymax: undefined | string,
  wednesdaymin: undefined | string,
  dateRange:Array<Moment | null>,
  startdate?:string,
  enddate?:string
}
interface payloadPolicy {
  fridaymax: undefined | string,
  fridaymin: undefined | string,
  mondaymax: undefined | string,
  mondaymin: undefined | string,
  ruledescription: string,
  rulenumber: string,
  saturdaymax: undefined | string,
  saturdaymin: undefined | string,
  sundaymax: undefined | string,
  sundaymin: undefined | string,
  thursdaymax: undefined | string,
  thursdaymin: undefined | string,
  tuesdaymax: undefined | string,
  tuesdaymin: undefined | string,
  wednesdaymax: undefined | string,
  wednesdaymin: undefined | string,
  startdate?:string,
  enddate?:string
}
interface CURoptionsType {
    codeName: string,
    codeType: string,
    codeValue: string,
    id: number,
    subCat: string | number | null
}
interface checkoutChargeType {
  ruledescription?: string, 
}
interface propsTypes {
    isEditable: ()=>void,
    cancelEditable: ()=>void,
    setOperationType: Dispatch<SetStateAction<string>>,
    detailData: {
      policies:{
        staypolicy:{
          generalminmaxpolicy: string,
          policies: Array<policyType>
        }
      }
    },
    supplier: string,
    propertyid: string,
    getPoliciesData: () => {},
    setPoliciesData: Dispatch<SetStateAction<string | null>>,
    model:string,
}

const DATAFORMAT = 'MM/DD/YYYY'

const CheckOutChargeEdit = (props: propsTypes) => {
    const [form] = Form.useForm()
    const [loadingFlag, setLoadingFlag] = useState(false)
    const [disableFlag, setDisableFlag] = useState(false)
    const [isEditModle, setIsEditModle] = useState(false)
    const [refreshKey, setRefreshKey] = useState<number>(0)
    const [disableDelete, setDisableDelete] = useState(true)

    const [generalStayList, setGeneralStayList] = useState<(checkoutChargeType | null)[]>(props?.detailData?.policies?.staypolicy?.policies)  
    const validateForm = (changeFlag?:boolean)=>{
      if(!isEditModle){
        return 
      }
      form.validateFields().then(() => {
        //if click cancel, do not change disableFlag
        !changeFlag && setDisableFlag(false)
      }).catch((err: { errorFields: { length: number }}) => {
        err?.errorFields?.length ? setDisableFlag(true) : setDisableFlag(false)
      });
    }

    const ondelete = async()=>{
      setDisableFlag(true)
      setLoadingFlag(true)
      let staypolicy = {
        generalminmaxpolicy:"",
        policies:[]
      }

      const property = {
        policies: {
            staypolicy: staypolicy
        }
      } 
    
      const response:generalType = await postHelper('/property/policies/staypolicy',{property})

      if (response?.result?.success) {
        setDisableFlag(false)
        setLoadingFlag(false)
        setIsEditModle(false)
        props.getPoliciesData()
      }

    }
    const save = async()=>{
      setDisableFlag(true)
      setLoadingFlag(true)
      let formValues = form.getFieldsValue()
      let values = {...formValues}
      let _policies:Array<payloadPolicy> = []
      let index = Object.keys(values)[0]
      if(values[index]?.dateRange || values[index]?.rulenumber || values[index]?.ruledescription){
        delete values.generalminmaxpolicy
        values.length = generalStayList.length
        let policies:Array<policyType> = Array.from(values)
        policies.forEach((item:policyType)=>{
          if(item){
            let obj = {
              rulenumber:item?.rulenumber ,
              ruledescription:item?.ruledescription ,
              sundaymin:item?.sundaymin ,
              sundaymax:item?.sundaymax ,
              mondaymin:item?.mondaymin ,
              mondaymax:item?.mondaymax ,
              tuesdaymin:item?.tuesdaymin ,
              tuesdaymax:item?.tuesdaymax ,
              wednesdaymin:item?.wednesdaymin ,
              wednesdaymax:item?.wednesdaymax ,
              thursdaymin:item?.thursdaymin ,
              thursdaymax:item?.thursdaymax ,
              fridaymin:item?.fridaymin ,
              fridaymax:item?.fridaymax ,
              saturdaymin:item?.saturdaymin ,
              saturdaymax:item?.saturdaymax ,
              startdate:item?.dateRange[0]?.format(DATAFORMAT) ,
              enddate:item?.dateRange[1]?.format(DATAFORMAT)
            }
            _policies.push(obj)
          }
        })
      }
      let staypolicy = {
        generalminmaxpolicy:formValues.generalminmaxpolicy,
        policies:_policies
      }

      const property = {
        policies: {
            staypolicy: staypolicy
        }
      } 
      const response:generalType = await postHelper('/property/policies/staypolicy',{property})
      if (response?.result?.success) {
        setDisableFlag(false)
        setLoadingFlag(false)
        setIsEditModle(false)
        props.getPoliciesData()
      }
    }
    const cancelFun = ()=>{
      //validate for clear error message
      validateForm(true)
      setIsEditModle(false)
      props.getPoliciesData()
    }

    const getInitialValues = ()=>{
      let policies = props?.detailData?.policies?.staypolicy.policies || [];
      policies.forEach((item:policyType) => {
        if(item.startdate && item.enddate){
          item.dateRange = [moment(item.startdate, DATAFORMAT),moment(item.enddate, DATAFORMAT)]
        }else{
          item.dateRange = [null, null]
        }
      });
      let value = Object(policies);
      value.generalminmaxpolicy = props?.detailData?.policies?.staypolicy.generalminmaxpolicy;
      return value;
    }

    const clearFields = (data:(checkoutChargeType | null)[])=>{
      if(!data.filter((item:checkoutChargeType|null)=>item).length){
        data[0] = {}
        form.setFields([
          {
            name:[0,'dateRange'],
            value:null
          },
          {
            name:[0,'rulenumber'],
            value:null
          },
          {
            name:[0,'ruledescription'],
            value:null
          },
          {
            name:[0,'sundaymin'],
            value:null
          },
          {
            name:[0,'sundaymax'],
            value:null
          },
          {
            name:[0,'mondaymin'],
            value:null
          },
          {
            name:[0,'mondaymax'],
            value:null
          },
          {
            name:[0,'tuesdaymin'],
            value:null
          },
          {
            name:[0,'tuesdaymax'],
            value:null
          },
          {
            name:[0,'wednesdaymin'],
            value:null
          },
          {
            name:[0,'wednesdaymax'],
            value:null
          },
          {
            name:[0,'thursdaymin'],
            value:null
          },
          {
            name:[0,'thursdaymax'],
            value:null
          },
          {
            name:[0,'fridaymin'],
            value:null
          },
          {
            name:[0,'fridaymax'],
            value:null
          },
          {
            name:[0,'saturdaymin'],
            value:null
          },
          {
            name:[0,'saturdaymax'],
            value:null
          },
        ])
      }
    }
    useEffect(()=>{
      validateForm()
    },[])

    useEffect(()=>{
      if(props.detailData.policies.staypolicy.policies[0].dateRange[0]){
        setDisableDelete(false) // enable delete if you have a field
      }
    },[])

    return (
      <>
        <PageContainer>
          <Card
            title='Max/Min Stay'
            headStyle={{ fontWeight: 600, fontSize: 14, color: '#333', paddingTop: '8px', paddingLeft: '4px' }}
            className={styles['stay-card-container']}
            extra={
              !isEditModle && (
                <Button
                  type='primary'
                  className='db-edit-btn'
                  onClick={() => {
                    setIsEditModle(true)
                  }}>
                  Edit
                </Button>
              )
            }>
            <Form
              form={form}
              layout='vertical'
              onValuesChange={() => {
                validateForm()
              }}
              initialValues={getInitialValues()}>
              <Row
                gutter={24}
                className={isEditModle ? undefined : styles['no-operation']}>
                <Col span={18} className='col-margin'>
                  <Form.Item
                    name='generalminmaxpolicy'
                    label='General Minimum Stay Policy'
                    rules={[
                      {
                        max: 600,
                        message:
                          'You have reached the max character length of 600',
                      },
                    ]}>
                    <TextArea
                      maxLength={600}
                      autoSize={{ minRows: 3, maxRows: 5 }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Collapse
                defaultActiveKey={generalStayList.map(
                  (_: checkoutChargeType | null, index: number) => `${index}`,
                )}
                multiCollapseButton
                ghost
                key={refreshKey}>
                {generalStayList.map(
                  (item: checkoutChargeType | null, index: number) => (
                    <React.Fragment key={index}>
                      {item && (
                        <Panel
                          collapsible={isEditModle ? 'header' : undefined}
                          className='panel-border panael-include-delete'
                          header={`Min/Max Stay Policy ${index + 1}`}
                          key={index}
                          extra={
                            isEditModle && (
                              <Popconfirm
                                key={index}
                                placement='leftTop'
                                title={`Are you sure you want to delete Min/Max Stay Policy ${
                                  index + 1
                                }?`}
                                onConfirm={() => {
                                  let _data = [...generalStayList]
                                  _data[index] = null
                                  clearFields(_data)
                                  setGeneralStayList(_data)
                                  validateForm()
                                }}
                                okText='Yes'
                                cancelText='No'>
                                <div
                                  id={index === 0 ? 'deleteStay1' : ''}
                                  className={`${styles['stay-delete-button']} panel-btn`}>
                                  <DeleteOutlined />
                                  <span className={styles['icon-margin']}>
                                    Delete
                                  </span>
                                </div>
                              </Popconfirm>
                            )
                          }>
                          <div
                            key={index}
                            className={
                              isEditModle ? undefined : styles['no-operation']
                            }>
                            <MinAndMaxStayItem index={index} />
                          </div>
                        </Panel>
                      )}
                    </React.Fragment>
                  ),
                )}
              </Collapse>
              {isEditModle && (
                <Button
                  type='link'
                  onClick={() => {
                    setDisableFlag(true)
                    setGeneralStayList(
                      generalStayList.concat({ ruledescription: '' }),
                    )
                    setRefreshKey(refreshKey + 1)
                  }}
                  icon={<PlusOutlined />}
                  className={styles['stay-add-button']}>
                  {`Add Min/Max Stay Policy`}
                </Button>
              )}
            </Form>
            <ActionButtonsBar
              onCancel={cancelFun}
              onSave={save}
              onDelete={ondelete}
              disabledDelete={disableDelete}
              disabledSave={disableFlag}
              show={isEditModle}
            />
          </Card>
        </PageContainer>
        {loadingFlag && (
          <div className={styles['stay-loading']}>
            <Loading type='large' />
          </div>
        )}
      </>
    )
}

export default CheckOutChargeEdit;



